import React from 'react'
import "./footer.css"

export const Footer = () => {
  return (
    <div className='myFooter'><strong> by Ángeles Godoy 🖤</strong></div>
  )
}
